var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnSearchBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_search_big",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn_search"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding_box",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2971085,21.0385142 L17.0610729,15.5927746 C18.4073497,13.9923815 19.1449826,11.9787593 19.1449826,9.88249132 C19.1449826,4.98476285 15.1602198,1 10.2624913,1 C5.36476285,1 1.38,4.98476285 1.38,9.88249132 C1.38,14.7802198 5.36476285,18.7649826 10.2624913,18.7649826 C12.101167,18.7649826 13.853335,18.2104062 15.3513865,17.1576379 L20.6272001,22.6447003 C20.8477176,22.8737142 21.1443155,23 21.4621542,23 C21.7630004,23 22.0483987,22.8853001 22.2650542,22.6767546 C22.7253991,22.2337886 22.7400744,21.4992452 22.2971085,21.0385142 Z M10.2624913,3.31717161 C13.8826858,3.31717161 16.8278109,6.26229682 16.8278109,9.88249132 C16.8278109,13.5026858 13.8826858,16.4478109 10.2624913,16.4478109 C6.64229682,16.4478109 3.69717161,13.5026858 3.69717161,9.88249132 C3.69717161,6.26229682 6.64229682,3.31717161 10.2624913,3.31717161 Z",
    id: "shape_search",
    fill: "#2D72FE",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnSearchBig);
export default __webpack_public_path__ + "static/media/icn_search_big.2beb5501158c52781e8a3e7700d26477.svg";
export { ForwardRef as ReactComponent };